import { HtmlFilePathResolver } from './HtmlFilePathResolver';

export function sketchToDocument(
  inputFiles: {
    name: string;
    path: string;
    content: string;
  }[],
  outBlobUrlSet: Set<string>,
): Document | undefined {
  console.log('sketchToDocument(): inputFiles:', inputFiles);
  const resolver = new HtmlFilePathResolver(inputFiles);
  try {
    const indexHtmlFile = HtmlFilePathResolver.findEntryPointHtml(
      resolver.sourceFiles.map((it) => it.path),
    );
    if (!indexHtmlFile) {
      console.log(
        'sketchToDocument(): HTML 파일이 없어서 렌더링할 수 없습니다',
        resolver.sourceFiles.join(','),
      );
      return undefined;
    }

    return resolver.start(indexHtmlFile);
  } catch (err: any) {
    resolver.resultBlobUrls.forEach((it) => {
      outBlobUrlSet.add(it);
    });
  }
}
